var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3703 25.3106C20.3703 26.9468 19.0442 28.2736 17.4069 28.2736C15.7704 28.2736 14.4443 26.9468 14.4443 25.3106C14.4443 23.6744 15.7704 22.3477 17.4069 22.3477C19.0442 22.3477 20.3703 23.6744 20.3703 25.3106Z",
    stroke: "#F57F20",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2 8.71774C6.09565 4.69148 11.7524 2.19922 18 2.19922C24.2476 2.19922 29.9051 4.69148 34 8.71774",
    stroke: "#F57F20",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14844 14.0513C9.03018 11.1227 13.0109 9.31055 17.4077 9.31055C21.8045 9.31055 25.7844 11.1227 28.667 14.0513",
    stroke: "#F57F20",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 18.7911C12.633 16.9602 15.0424 15.8281 17.7031 15.8281C20.3646 15.8281 22.7739 16.9602 24.5183 18.7911",
    stroke: "#F57F20",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/Good.22748e094b43952e318404543ac68fae.svg";
export { ForwardRef as ReactComponent };